module.exports = "/_next/static/images/kamlesh-58e4469d4e39c72255349f425414e60d.png";